/* AppraisalComponents/FasteningPositionPicker.jsx
 * Phase C · Row-scoped Tile Rescrew UI (2026-02c).
 *
 * Small inline <select> rendered inside the Fastening details strip
 * (see ComponentLineRow.js). Only visible when the current appraisal
 * is a tile-rescrew quote. Picking a position writes `row_position`
 * onto the line and triggers `useTileRescrewRowCascade` at the parent
 * level, which fires the appropriate FST-Rescrew-Tile-* engine rule
 * and cascades the matching fastenings rate row onto the line.
 *
 * Props:
 *   value      - current line.row_position ('', 'bottom', 'ridge', 'barge')
 *   onChange   - (newPosition) => void — parent wires this to onUpdate({row_position})
 *   testidRef  - ref_id string used to build the data-testid
 */
import React from 'react';

const OPTIONS = [
  { value: '',       label: '— Position —' },
  { value: 'bottom', label: 'Bottom Course' },
  { value: 'ridge',  label: 'Ridge Cap' },
  { value: 'barge',  label: 'Barge' },
];

export function FasteningPositionPicker({ value, onChange, testidRef }) {
  return (
    <>
      <span className="h-4 w-px bg-rose-200" aria-hidden="true" />
      <span
        className="text-[9px] font-bold uppercase tracking-[0.18em] text-rose-700 shrink-0"
        title="Bottom / Ridge / Barge fixing kind for a tile-rescrew job. Picks the correct screw automatically (12*50 vs 30mm Flathead Washer)."
      >
        Position
      </span>
      <select
        data-testid={`comp-line-fastening-position-${testidRef}`}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className="text-[10px] px-1.5 py-0.5 border border-rose-200 rounded bg-white text-slate-700"
      >
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </>
  );
}
